module.exports = __webpack_public_path__ + "img/cloud2.ab5f0ed1.png";